const presentContinuousVerbs = [
    "Running",
    "Jumping",
    "Singing",
    "Dancing",
    "Eating",
    "Sleeping",
    "Writing",
    "Reading",
    "Talking",
    "Listening",
    "Driving",
    "Walking",
    "Swimming",
    "Flying",
    "Laughing",
    "Crying",
    "Cooking",
    "Baking",
    "Painting",
    "Drawing",
    "Climbing",
    "Playing",
    "Studying",
    "Working",
    "Relaxing",
    "Thinking",
    "Learning",
    "Teaching",
    "Building",
    "Creating",
    "Designing",
    "Solving",
    "Chatting",
    "Planting",
    "Growing",
    "Praying",
    "Surfing",
    "Typing",
    "Coding",
    "Programming",
    "Exploring",
    "Planning",
    "Shopping",
    "Selling",
    "Buying",
    "Loving",
    "Hating",
    "Admiring",
    "Respecting",
    "Fearing",
    "Enjoying",
    "Disagreeing",
    "Agreeing",
    "Encouraging",
    "Inspiring",
    "Supporting",
    "Opposing",
    "Sharing",
    "Caring",
    "Daring",
    "Imagining",
    "Expressing",
    "Clapping",
    "Snapping",
    "Pointing",
    "Whispering",
    "Complaining",
    "Discussing",
    "Solving",
    "Procrastinating",
    "Brushing",
    "Shouting",
    "Demanding",
    "Responding",
    "Receiving",
    "Complimenting",
    "Worrying",
    "Wondering",
    "Waiting",
    "Struggling",
    "Succeeding",
    "Failing",
    "Managing",
    "Visiting",
    "Hiking",
    "Singing",
    "Dancing",
    "Traveling",
    "Painting",
    "Writing",
    "Drawing",
    "Talking",
    "Listening",
    "Driving",
    "Walking",
    "Swimming",
    "Running",
    "Jumping",
    "Cooking",
    "Baking"
];

const animalNames = [
    "Lion", "Tiger", "Elephant", "Giraffe", "Zebra",
    "Rhino", "Hippopotamus", "Gorilla", "Chimpanzee", "Kangaroo",
    "Koala", "Panda", "Bear", "Wolf", "Fox", "Deer", "Rabbit", "Squirrel",
    "Hedgehog", "Raccoon", "Otter", "Beaver", "Dolphin", "Whale", "Shark",
    "Octopus", "Jellyfish", "Seahorse", "Penguin", "Ostrich", "Flamingo",
    "Peacock", "Parrot", "Toucan", "Eagle", "Hawk", "Owl", "Falcon", "Sparrow",
    "Hummingbird", "Crocodile", "Alligator", "Turtle", "Snake", "Lizard",
    "Frog", "Toad", "Salamander", "Newt", "Gecko", "Armadillo", "Anteater",
    "Sloth", "Koala", "Platypus", "Tasmanian Devil", "Wombat", "Mole", "Bat",
    "Horse", "Cow", "Pig", "Sheep", "Goat", "Rabbit", "Chicken", "Duck",
    "Turkey", "Goose", "Pigeon", "Pheasant", "Quail", "Swan", "Alpaca", "Llama",
    "Camel", "Giraffe", "Donkey", "Elephant", "Rhinoceros", "Hippopotamus",
    "Cheetah", "Jaguar", "Leopard", "Lynx", "Panther", "Snow Leopard",
    "Bobcat", "Caracal", "Meerkat", "Ocelot", "Raccoon", "Red Panda",
    "Ring-Tailed Lemur", "Tapir", "Tasmanian Tiger", "Wombat", "Yak",
    "Okapi", "Aardvark"
];

var verb = presentContinuousVerbs[Math.floor(Math.random() * presentContinuousVerbs.length)]
var animal = animalNames[Math.floor(Math.random() * animalNames.length)]
var name = verb + ' ' + animal;
export { name };


